import _ from 'underscore';
import xtend from 'xtend';
import struct from 'observ-struct';
import reactUpdate from 'react-addons-update';

import Utilities from '../utils/Utilities.js';
import Store from '../lib/store/store-v2';

function parseEventId (id) {
    return id.indexOf('_') === -1 ? id : id.split('_')[1];
}

function getAssetIndexById (event, assetID) {
    if (event && event.mediaAssets) {
        for (var i = 0; i < event.mediaAssets.length; i++) {
            if (event.mediaAssets[i].assetID == assetID) return i;
        }
    }
    return -1;
}

function findPendingMiscTransferMatch (event, name) {
    for (var i = 0; i < event.mediaAssets.length; i++) {
        if (
            event.mediaAssets[i].currevent == 'placeholder' &&
            event.mediaAssets[i].name == name
        ) return i;
    }
    return false;
}

export default function EventStore (apiBus, socketBus, markersBus, facebookLiveBus) {
    const KEY = 'eventID';
    var state = Store();
    var eventAjaxState = struct({});

    // {"success":true,"data":{"eventID":"1000000000_2016101004","clientID":"1000000000"}}
    function deleteEvent (event) {
        // console.log('deleteEvent', event, state.data()[event.data[KEY]]);
        if (event.data[KEY].indexOf('_') !== -1) event.data[KEY] = event.data[KEY].split('_')[1];
        if (state.data()[event.data[KEY]]) {
            var data = state.data();
            delete data[event.data[KEY]];
            state.set(xtend(state(), {
                data: data,
                isResolving: false
            }));
        }
    }

    function websocketDelete (event) {
        switch (event.action.method) {
            case 'event':
            case 'events':
                // console.log('websocketDelete');
                deleteEvent(event);
                break;

            case 'asset':
                var ev = state.data()[event.data.eventID];
                if (!ev) break;

                // update that event so the asset is not there
                var matchingAsset = _(ev.mediaAssets).findWhere({
                    assetID: event.data.assetID
                });
                var updatedEv = {};
                updatedEv[ev.eventID] = xtend(ev, {
                    mediaAssets: _(ev.mediaAssets).without(matchingAsset)
                });
                state.data.set(xtend(state.data(), updatedEv));
                break;

            case 'categories':
                // Go through all events and remove the category (by name, as they
                // will only have strings but are guaranteed to be unique).
                var updates = {};
                var events = _.toArray(state.data());
                // var categories = _(metadataStore.state().categories.data).indexBy('categoryID');
                // var parent = categories[event.data.categoryID];

                events.map(function (ev) {
                    if (ev.categories) {
                        var categoryIndex = ev.categories.indexOf(parent.categoryName);
                        if (categoryIndex > -1) {
                            updates[ev[KEY]] = {};
                            updates[ev[KEY]].categories = {$splice: [[categoryIndex, 1]]};
                        }
                    }
                }, this);

                state.data.set(reactUpdate(state.data(), updates));
                break;
        }
    }

    function update (event) {

        if (event && event.data !== null) {
            var newData;

            switch (event.action.method) {
                /*
                    @NOTE this will work for the Encoders once the encoder socket
                    spec is finalized so we'll keep it how it is.
                 */
                case 'event':
                case 'events':
                case 'publish':
                case 'unpublish':
                    if (state.data()[event.data[KEY]]) {
                        newData = {};
                        newData[event.data[KEY]] = {$set: event.data};
                        state.data.set(reactUpdate(state.data(), newData));
                    }
                    break;

                /*
                    @FIXME
                    This could be a Misc. Asset update I think too
                 */
                case 'asset':
                    if (state.data()[event.data[KEY]]) {
                        newData = {};
                        newData[event.data[KEY]] = {};
                        newData[event.data[KEY]]['mediaAssets'] = [];

                        var index = getAssetIndexById(state.data()[event.data[KEY]], event.data.assetID);

                        switch (event.action.type) {
                            case 'edit':
                                if (index != -1) {
                                    newData[event.data[KEY]]['mediaAssets'] = {$splice: [[
                                        index, 1, event.data
                                    ]]};
                                    state.data.set(reactUpdate(state.data(), newData));
                                }
                                break;

                            case 'add':

                                var pendingTransferIndex = findPendingMiscTransferMatch(state.data()[event.data[KEY]], event.data.name);

                                if (pendingTransferIndex) {
                                    var pendingMiscReplace = xtend(
                                        state.data()[event.data[KEY]].mediaAssets[pendingTransferIndex],
                                        event.data
                                    );
                                    newData[event.data[KEY]]['mediaAssets'][pendingTransferIndex] = {$set: pendingMiscReplace};
                                } else if (index == -1) {
                                    newData[event.data[KEY]]['mediaAssets'] = {$push: [event.data]};
                                } else {
                                    // This is a placeholder 'add'
                                    var placeholderReplacement = xtend(
                                        state.data()[event.data[KEY]].mediaAssets[index],
                                        event.data
                                    );
                                    newData[event.data[KEY]]['mediaAssets'][index] = {$set: placeholderReplacement};
                                }
                                state.data.set(reactUpdate(state.data(), newData));
                                break;
                        }
                    }
                    break;

                case 'encoder':
                    var effectedEvents = [];

                    Object.keys(state.data()).map(function (id) {
                        if (state.data()[id].assignedEncoder && state.data()[id].assignedEncoder == event.data.encoderID) {
                            effectedEvents.push(id);
                        }
                    });

                    if (effectedEvents.length) {
                        effectedEvents.map(function (id) {
                            newData = {};
                            newData[id] = {};
                            newData[id]['encoderDetails'] = {$set: event.data};
                            state.data.set(reactUpdate(state.data(), newData));
                        });
                    }
                    break;

                case 'transcode': {
                    const { data: stateData } = state;
                    const { data: eventData, action: { type } } = event;
                    const key = eventData[KEY];
                
                    if (stateData()[key]) {
                        const index = getAssetIndexById(stateData()[key], eventData.assetID);
                        if (index !== -1) {
                            const mediaAssets = stateData()[key].mediaAssets;
                            const assetToUpdate = mediaAssets[index];
                
                            let updatedAsset;
                            if (type === 'processing') {
                                updatedAsset = {
                                    ...assetToUpdate,
                                    transcodeProgress: eventData,
                                    currentStatus: 'transcoding'
                                };
                            } else if (type === 'start' || type === 'complete') {
                                updatedAsset = { ...assetToUpdate, ...eventData };
                            }
                
                            if (updatedAsset) {
                                const newMediaAssets = [...mediaAssets];
                                newMediaAssets[index] = updatedAsset;
                
                                state.data.set(
                                    reactUpdate(stateData(), {
                                        [key]: {
                                            ...stateData()[key],
                                            mediaAssets: newMediaAssets
                                        }
                                    })
                                );
                            }
                        }
                    }
                    break;
                }

                case 'thumbs':
                    var assetData = (_.isArray(event.data)) ? event.data[0] : false;

                    if (assetData && state.data()[assetData[KEY]]) {

                        newData = {};
                        var index = getAssetIndexById(state.data()[assetData[KEY]], assetData.assetID);

                        if (index != -1) {
                            switch (event.action.type) {
                                /**
                                 * @NOTE on '/Thumbs/replace' API socket msg
                                 *
                                 * Because there's no new data coming in over
                                 * the socket – as the thumbnail will be updated
                                 * and retain the same URL as before – we add a
                                 * placebo property which can be ignored everywhere
                                 * else but which will trigger observ-struct's
                                 * onChange event to fire.
                                 *
                                 * Because multiple 'edit' thumb msgs may come
                                 * through, we make the property's value a random
                                 * string to ensure each updates the view.
                                 */
                                case 'add':
                                case 'edit':
                                case 'update':
                                    var updatedAsset = xtend(
                                        state.data()[assetData[KEY]].mediaAssets[index],
                                        { mockUpdate: Utilities.generateUid(6) },
                                        assetData
                                    );

                                    newData[assetData[KEY]] = {};
                                    newData[assetData[KEY]]['mediaAssets'] = [];
                                    newData[assetData[KEY]]['mediaAssets'][index] = {
                                        $merge: updatedAsset
                                    };

                                    // console.log(state.data(), assetData, newData, updatedAsset, index);
                                    state.data.set(reactUpdate(state.data(), newData));
                                    break;
                            }
                        }
                    }
                    break;

                default:
                    console.warn('Unhandled Websocket Actions (update): [%s], %o', event.action.method + ':' + event.action.type, event);
            }
        }
    }

    function updateResponseHandler (resp) {
        if (!resp) return;
        var newData = {};
        newData[resp.data[KEY]] = resp.data;
        state.set({
            data: xtend(state.data(), newData),
            isResolving: false
        });
    }

    var apiActions = Store.ApiActions(state, KEY, {
        get: function (event) {
            var events = _(event.data).indexBy(KEY);
            var mapped = {};
            _.forEach(Object.keys(events), function (id) {
                mapped[id] = false;
            });
            eventAjaxState.set(mapped);
            state.set(xtend(state(), {
                isResolving: false,
                data: events
            }));
        },
        editLink: updateResponseHandler,
        edit: updateResponseHandler,
        start: updateResponseHandler,
        stop: updateResponseHandler,
        publish: updateResponseHandler,
        unpublish: updateResponseHandler,
        delete: deleteEvent,

        // ApiAdapter -> miscAssetToEvent:
        // {data: resp.data}, {opts: opts}
        miscAssetToEvent: function (resp) {
            if (resp.data) {
                var placeholder = xtend(resp.data, {
                    currentStatus: 'placeholder',
                    eventID: resp.opts.eventID
                });

                var newData = {};
                newData[placeholder[KEY]] = {};
                newData[placeholder[KEY]]['mediaAssets'] = [];
                newData[placeholder[KEY]]['mediaAssets'] = {$push: [placeholder]};
                state.data.set(reactUpdate(state.data(), newData));
            }
        }
    });

    function upsertProperty (property, response) {
        var eventID;
        try {
            switch (property) {
                case 'eventMetaMarkers':
                    eventID = parseEventId(response.data[0].eventID); break;

                case 'facebookLive':
                    eventID = parseEventId(response.data.eventID); break;
            }
            if (!state.data()[eventID]) return;
        } catch (e) {
            console.warn('Event Store => upsertProperty: ', e);
            return;
        } finally {
            var newEv = xtend(state.data()[eventID]);
            if (newEv.hasOwnProperty(property)) {
                newEv[property] = response.data;
                var newData = {};
                newData[newEv.eventID] = newEv;
                state.data.set(xtend(state.data(), newData));
            } else {
                console.warn("Event Store: Expected Property Not Found (%s), %o", property, response);
            }
        }
    }

    // function upsertMarker (resp) {
    //     var evId = parseEventId(resp.data[0].eventID);
    //     if (!state.data()[evId]) return console.log('that event doesnt exist');
    //     var newEv = xtend(state.data()[evId]);
    //     newEv.eventMetaMarkers = resp.data;
    //     var newData = {};
    //     newData[newEv.eventID] = newEv;
    //     state.data.set(xtend(state.data(), newData));
    // }

    function deleteMarker (resp) {
        var evId = parseEventId(resp.data.eventID);
        if (!state.data()[evId]) return console.log('that event doesnt exist');
        var newEv = xtend(state.data()[evId]);
        var markerToDel = _(newEv.eventMetaMarkers)
            .findWhere({ markerID: resp.data.markerID })
        ;
        console.log('marker to del', markerToDel);
        var newMarkers = _(newEv.eventMetaMarkers).without(markerToDel);
        newEv.eventMetaMarkers = newMarkers;
        var newData = {};
        newData[newEv.eventID] = newEv;
        state.data.set(xtend(state.data(), newData));
    }

    var markersApiActions = {
        edit: upsertProperty.bind(null, 'eventMetaMarkers'),
        add: upsertProperty.bind(null, 'eventMetaMarkers'),
        delete: deleteMarker
    };
    Store.Subscribe(
        Object.keys(markersApiActions), markersApiActions,markersBus
    );

    function deleteFacebookLive (response) {
        var eventID;
        try {
            eventID = parseEventId(response.data.eventID);
            if (!state.data()[eventID]) return;
        } catch (e) {
            console.warn('Event Store => deleteFacebookLive: ', e);
            return;
        } finally {
            var newEv = xtend(state.data()[eventID]);
            newEv.facebookLive = null;
            var newData = {};
            newData[newEv.eventID] = newEv;
            state.data.set(xtend(state.data(), newData));
        }
    }

    var facebookLiveActions = {
        add: upsertProperty.bind(null, 'facebookLive'),
        edit: upsertProperty.bind(null, 'facebookLive'),
        delete: deleteFacebookLive
    };
    Store.Subscribe(
        Object.keys(facebookLiveActions), facebookLiveActions, facebookLiveBus
    );

    // function handleTranscriptResponse (a,b,c) {
    //     console.log(a,b,c);
    // }
    // var transcriptActions = {
    //     get: handleTranscriptResponse,
    //     add: handleTranscriptResponse,
    //     resubmit: handleTranscriptResponse,
    //     setUseText: handleTranscriptResponse,
    //     setUseAsCaptions: handleTranscriptResponse,
    // };
    // Store.Subscribe(
    //     Object.keys(transcriptActions),
    //     transcriptActions,
    //     transcriptBus
    // );

    Store.SubscribeToApi(apiActions, apiBus);

    var socketActions = Store.WebsocketActions(state, KEY, {
        start: update,
        stop: Store.WebsocketActions.prototype.update,
        delete: websocketDelete,
        update: update,
        add: update,
        edit: update,
        connect: update,
        disconnected: update,
        publish: update,
        unpublish: update,
        processing: update,
        complete: update,
        thumbs: update
    });

    var wsEvents = Store.WebsocketEvents.concat([
        'complete',
        'connect',
        'disconnected',
        'processing',
        'publish',
        'start',
        'stop',
        'thumbs',
        'unpublish'
    ]);

    Store.SubscribeToWebsocket(wsEvents, socketActions, socketBus);

    return {
        state: Store.Parse(state, function (data) {
            return (xtend(data, { data: _.toArray(data.data) }));
        }),
        eventAjaxState: eventAjaxState,
        update: updateResponseHandler
    };
};
